import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { routes } from './enrollment.routes'
import { NgxPaginationModule } from 'ngx-pagination'
import { OrderModule } from 'ngx-order-pipe'
import { FilterPipeModule } from 'ngx-filter-pipe'
import { ExcelService } from './excel.service'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { HttpRequestInterceptor } from '../interceptor/http-request-interceptor'
import { ValidationModule } from '../validations/validation.module'
import { StateGateway } from '../common/gateways/state-gateway'
import { NetworkStateGateway } from '../common/gateways/network-state-gateway'
import { ConfigurableAddressComponent } from '../common/components/address-group/configurable-address.component'
import { DualAddressComponent } from '../common/components/address-group/dual-address.component'
import { EAppEnrollmentComponent } from './components/e-app-enrollment/e-app-enrollment.component'
import { EAppEnrollmentReadonlyComponent } from './components/e-app-enrollment/e-app-enrollment-readonly.component'
import { EAppInformationComponent } from './components/e-app-enrollment/e-app-information.component'
import { EAppHistoryComponent } from './components/e-app-enrollment/e-app-history.component'
import { EAppEnrollmentButtonComponent } from './components/e-app-enrollment/e-app-enrollmentbutton.component'
import { EAppEnrollmentMessagesComponent } from './components/e-app-enrollment/e-app-enrollmentmessages.component'
import { ExternalAgentEnrollmentComponent } from './components/external-agent-enrollment/external-agent-enrollment.component'
import { PaymentMethodComponent } from './components/common/payment-method.component'
import { DrugPlanComponent } from './components/common/drug-plan.component'
import { GroupPlanComponent } from './components/common/group-plans.component'
import { NotesComponent } from './components/common/notes.component'
import { PaymentAccountFormComponent } from './components/common/payment-account-form.component'
import { EnrollmentApplicationClientComponent } from './components/common/enrollment-application-client.component'
import { EAppStage2EnrollmentComponent } from './components/e-app-stage2-enrollment/e-app-stage2-enrollment.component'
import { EnrollmentLayoutComponent } from './components/layout/enrollment-layout.component'
import { BeneficiaryInformationComponent } from './components/common/beneficiary-information.component'
import { ExplanationOfBenefitComponent } from './components/common/explanation-of-benefits.component'
import { ElectionPeriodComponent } from './components/common/election-period.component'
import { EnrollmentGateway } from './gateways/enrollment-gateway'
import { NetworkEnrollementGateway } from './gateways/network-enrollment-gateway'
import { CommonEnrollmentLayoutComponent } from './components/layout/common-enrollment-layout.component'
import { EnrollmentHeaderComponent } from './components/header/enrollment-header.component'
import { DataEntryStep1Component } from './components/data-entry-enrollment/data-entry-step1.component'
import { DataEntryStep2Component } from './components/data-entry-enrollment/data-entry-step2.component'
import { DataEntryStep3Component } from './components/data-entry-enrollment/data-entry-step3.component'
import { EnrollmentDataService } from './gateways/enrollment-data-service'
import { PrescriptionDrug } from './components/common/prescription-drug-component'
import { DataEntryLayoutEnrollmentStep2 } from './components/common/layout/dataentry-layout-enrollment-step2'
import { DataEntryStep4Component } from './components/data-entry-enrollment/data-entry-step4.component'
import { DataEntryStep5Component } from './components/data-entry-enrollment/data-entry-step5.component'
import { ConfirmEnrollmentDetailComponent } from './components/common/confirm-enrollment-detail.component'
import { GroupEnrollmentComponent } from './components/group-enrollment/group-enrollment.component'
import { GetExcel } from './get.excel'
import { FileUploadModule } from 'ng2-file-upload'
import { EnrollmentPageComponent } from '../enrollment/components/enrollment-page/enrollment-page.component'
import { VerifyEAppComponent } from './components/e-app-enrollment/verify.component'
import { ConfirmationComponent } from './components/data-entry-enrollment/confirmation.component'
import { EnrollmentMethodAndSoaComponent } from './components/external-agent-enrollment/enrollment-method-and-soa.component'
import { TermsOfServiceComponent } from './components/external-agent-enrollment/terms-of-service.component'
import { PowerOfAttorneyFormComponent } from './components/common/power-of-attorney-form.component'
import { SharedModule } from '../shared/shared.module'
import { SendEmailEnrollmentComponent } from './components/send-email-enrollment/Send-EmailEnrollment'
import { ReactiveFormsModule } from '@angular/forms'
import { Enrollments } from '../enrollment/components/enrollments/enrollments.component'
import { UserManagementModule } from '../user-management/user-management.module'
import { ExternalAgentStep1 } from './components/external-agent-enrollment/external-agent-step1.component'
import { ExternalAgentStep3 } from './components/external-agent-enrollment/external-agent-step3.component'
import { ExternalAgentStep4 } from './components/external-agent-enrollment/external-agent-step4.component'
import { ExternalAgentStep5 } from './components/external-agent-enrollment/external-agent-step5.component'
import { ExternalAgentCheckList } from './components/external-agent-enrollment/external-agent-check-list'
import { PrintPdf } from './components/common/print-pdf'
import { PhoneEnrollmentStep1Component } from './components/phone-enrollment/ssi/phone-enrollment-step1.component'
import { PortalCommonModule } from '../common/portal-common.module'
import { STCOBComponent } from './components/common/STCOB-Fields.component'
import { CreditCoverage } from './components/common/creditable-coverage.component'
import { PhoneEnrollmentStep2Component } from './components/phone-enrollment/ssi/phone-enrollment-step2.component'
import { PhoneEnrollmentStep3Component } from './components/phone-enrollment/ssi/phone-enrollment-step3.component'
import { PhoneEnrollmentStep4Component } from './components/phone-enrollment/ssi/phone-enrollment-step4.component'
import { PhoneEnrollmentStep5Component } from './components/phone-enrollment/ssi/phone-enrollment-step5.component'
import { PhoneEnrollmentPreviewComponent } from './components/phone-enrollment/ssi/phone-enrollment-preview.component'
import { PhoneEnrollmentConfirmationComponent } from './components/phone-enrollment/ssi/phone-enrollment-confirmation.component'
import { PhoneEnrollmentFinalComponent } from './components/phone-enrollment/ssi/phone-enrollment-final.component'
import { PhoneEnrollmentExtStep1Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step1.component'
import { PhoneEnrollmentExtStep2Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step2.component'
import { PhoneEnrollmentExtStep3Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step3.component'
import { PhoneEnrollmentExtStep4Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step4.component'
import { PhoneEnrollmentExtStep5Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step5.component'
import { PhoneEnrollmentExtPreviewComponent } from './components/phone-enrollment/ssi/ext/phone-enrollment-preview.component'
import { PhoneEnrollmentExtConfirmationComponent } from './components/phone-enrollment/ssi/ext/phone-enrollment-confirmation.component'
import { PhoneEnrollmentExtFinalComponent } from './components/phone-enrollment/ssi/ext/phone-enrollment-final.component'
import { BeneficiaryDetailsComponent } from './components/phone-enrollment/ssi/beneficiarydetails.component'
import { ExternalEnrollmentLanding } from './components/ExternalEnrollmentLanding/External-Enrollment-Landing.component'
import { callStartGateway } from '../call-start/gateways/call-start-gateway'
import { NetworkCallStartGateway } from '../call-start/gateways/network-call-start-gateway'
import { ClsIPadHistory } from './components/ipadhistory/ipadhistory-component'
import { MemberIPadService } from './gateways/enrollment-data-service'
import { ClsIPadLoginHistory } from './components/ipad-login-history/ipadloginhistory-component'
import { NetworkTrainingCertificatesGateway } from '../training/gateways/network-training-certificates-gateway'
import { TrainingCertificatesGateway } from '../training/gateways/training-certificates-gateway'
import { JqxGridVirtualPaging } from '../common/utilclasses/jqxgrid-virtualpaging'
import { NEJEPhoneEnrollmentStep1Component } from './components/phone-enrollment/neje/phone-enrollment-step1.component'
import { NEJEPhoneEnrollmentStep2Component } from './components/phone-enrollment/neje/phone-enrollment-step2.component'
import { NEJEPhoneEnrollmentStep3Component } from './components/phone-enrollment/neje/phone-enrollment-step3.component'
import { NEJEPhoneEnrollmentConfirmationComponent } from './components/phone-enrollment/neje/phone-enrollment-confirmation.component'
import { NEJEPhoneEnrollmentPreviewComponent } from './components/phone-enrollment/neje/phone-enrollment-preview.component'
import { NEJEPhoneEnrollmentFinalComponent } from './components/phone-enrollment/neje/phone-enrollment-final.component'
import { NEJEBeneficiaryDetailsComponent } from './components/phone-enrollment/neje/beneficiarydetails.component'
import { NEJEDataEntryStep1Component } from './components/data-entry-enrollment/neje/data-entry-step1.component'
import { NEJEDataEntryStep2Component } from './components/data-entry-enrollment/neje/data-entry-step2.component'
import { NEJEDataEntryStep3Component } from './components/data-entry-enrollment/neje/data-entry-step3.component'
import { NEJEDataEntryStep4Component } from './components/data-entry-enrollment/neje/data-entry-step4.component'
import { NEJEDataEntryStep5Component } from './components/data-entry-enrollment/neje/data-entry-step5.component'
import { NEJEConfirmationComponent } from './components/data-entry-enrollment/neje/confirmation.component'
import { NEJESingleGroupStep1Component } from './components/group-enrollment/neje/single-group-step1.component'
import { NEJESingleGroupStep2Component } from './components/group-enrollment/neje/single-group-step2.component'
import { NEJESingleGroupStep3Component } from './components/group-enrollment/neje/single-group-step3.component'
import { NEJESingleGroupStep4Component } from './components/group-enrollment/neje/single-group-step4.component'
import { NEJESingleGroupStep5Component } from './components/group-enrollment/neje/single-group-step5.component'
import { NEJESingleGroupConfirmationComponent } from './components/group-enrollment/neje/single-group-confirmation.component'
import { PhoneEnrollmentSpanishStep1Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step1.component'
import { PhoneEnrollmentSpanishStep2Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step2.component'
import { PhoneEnrollmentSpanishStep3Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step3.component'
import { PhoneEnrollmentSpanishStep4Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step4.component'
import { PhoneEnrollmentSpanishStep5Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step5.component'
import { PhoneEnrollmentSpanishPreviewComponent } from './components/phone-enrollment/ssi/spanish/phone-enrollment-preview.component'
import { PhoneEnrollmentSpanishFinalComponent } from './components/phone-enrollment/ssi/spanish/phone-enrollment-final.component'
import { BeneficiaryDetailsSpanishComponent } from './components/phone-enrollment/ssi/spanish/beneficiarydetails.component'
import { RaceEthnicityComponent } from './components/common/race-ethnicity.component'
import { AccessibilityComponent } from './components/common/accessibility.component'
import { GenderPrefComponent } from './components/common/gender-pref.component'
import { IndvRepComponent } from './components/common/indvrep.component'
import { IndEnrollmentComponent } from './components/ind-enrollment/Ind-Enrollment'

@NgModule({
    declarations: [
        EAppEnrollmentComponent,
        EAppEnrollmentReadonlyComponent,
        ConfigurableAddressComponent,
        DualAddressComponent,
        ExternalAgentEnrollmentComponent,
        BeneficiaryInformationComponent,
        PaymentMethodComponent,
        DrugPlanComponent,
        NotesComponent,
        DataEntryStep1Component,
        DataEntryStep2Component,
        DataEntryStep3Component,
        DataEntryStep4Component,
        DataEntryStep5Component,
        DrugPlanComponent,
        SendEmailEnrollmentComponent,
        IndEnrollmentComponent,
        NotesComponent,
        CommonEnrollmentLayoutComponent,
        ElectionPeriodComponent,
        EnrollmentHeaderComponent,
        EnrollmentLayoutComponent,
        EnrollmentApplicationClientComponent,
        PaymentAccountFormComponent,
        PrescriptionDrug,
        DataEntryLayoutEnrollmentStep2,
        EAppStage2EnrollmentComponent,
        PaymentAccountFormComponent,
        ConfirmEnrollmentDetailComponent,
        GroupEnrollmentComponent,
        EAppHistoryComponent,
        EnrollmentPageComponent,
        EAppInformationComponent,
        Enrollments,
        EnrollmentMethodAndSoaComponent,
        ExplanationOfBenefitComponent,
        TermsOfServiceComponent,
        PowerOfAttorneyFormComponent,
        ConfirmationComponent,
        VerifyEAppComponent,
        ExternalAgentStep1,
        ExternalAgentStep3,
        ExternalAgentStep4,
        ExternalAgentStep5,
        ExternalAgentCheckList,
        EAppEnrollmentButtonComponent,
        ExternalAgentCheckList,
        PrintPdf,
        EAppEnrollmentMessagesComponent,
        PhoneEnrollmentStep1Component,
        // EnrollmentFooterComponent,
        STCOBComponent,
        CreditCoverage,
        PhoneEnrollmentStep2Component,
        PhoneEnrollmentStep3Component,
        PhoneEnrollmentStep4Component,
        PhoneEnrollmentStep5Component,
        PhoneEnrollmentPreviewComponent,
        PhoneEnrollmentConfirmationComponent,
        PhoneEnrollmentFinalComponent,
        PhoneEnrollmentExtStep1Component,
        PhoneEnrollmentExtStep2Component,
        PhoneEnrollmentExtStep3Component,
        PhoneEnrollmentExtStep4Component,
        PhoneEnrollmentExtStep5Component,
        PhoneEnrollmentExtPreviewComponent,
        PhoneEnrollmentExtConfirmationComponent,
        PhoneEnrollmentExtFinalComponent,
        BeneficiaryDetailsComponent,
        ClsIPadHistory,
        ExternalEnrollmentLanding,
        ClsIPadLoginHistory,
        NEJEPhoneEnrollmentStep1Component,
        NEJEPhoneEnrollmentStep2Component,
        NEJEDataEntryStep1Component,
        NEJEDataEntryStep2Component,
        NEJEDataEntryStep3Component,
        NEJEDataEntryStep4Component,
        NEJEDataEntryStep5Component,
        NEJEConfirmationComponent,
        NEJEBeneficiaryDetailsComponent,
        NEJEPhoneEnrollmentConfirmationComponent,
        NEJEPhoneEnrollmentFinalComponent,
        NEJEPhoneEnrollmentStep3Component,
        NEJEPhoneEnrollmentPreviewComponent,
        NEJESingleGroupStep1Component,
        NEJESingleGroupStep2Component,
        NEJESingleGroupStep3Component,
        NEJESingleGroupStep4Component,
        NEJESingleGroupStep5Component,
        NEJESingleGroupConfirmationComponent,
        GroupPlanComponent,
        PhoneEnrollmentSpanishStep1Component,
        PhoneEnrollmentSpanishStep2Component,
        PhoneEnrollmentSpanishStep3Component,
        PhoneEnrollmentSpanishStep4Component,
        PhoneEnrollmentSpanishStep5Component,
        PhoneEnrollmentSpanishPreviewComponent,
        PhoneEnrollmentSpanishFinalComponent,
        BeneficiaryDetailsSpanishComponent,
        RaceEthnicityComponent,
        AccessibilityComponent,
        GenderPrefComponent,
        IndvRepComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        ValidationModule,
        ReactiveFormsModule,
        FileUploadModule,
        //  DropDownsModule,
        NgxPaginationModule,
        OrderModule,
        FilterPipeModule,
        UserManagementModule,
        SharedModule,
        PortalCommonModule,
        RouterModule.forChild(routes)
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
        { provide: StateGateway, useClass: NetworkStateGateway },
        { provide: EnrollmentGateway, useClass: NetworkEnrollementGateway },
        { provide: EnrollmentDataService, useClass: EnrollmentDataService },
        { provide: callStartGateway, useClass: NetworkCallStartGateway },
        { provide: MemberIPadService, useClass: MemberIPadService },
        { provide: TrainingCertificatesGateway, useClass: NetworkTrainingCertificatesGateway },
        GetExcel,
        ExcelService,
        JqxGridVirtualPaging,
        { provide: IndvRepComponent, useClass: IndvRepComponent },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class EnrollmentModule {}
